<template>
    <b-input-group>
        <b-form-input ref="input"
                      :value="value"
                      :type="type"
                      :required="required"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      :autocomplete="autocomplete"
                      @input="changed"/>
        <b-input-group-append>
            <b-btn :disabled="disabled"
                   ref="generatePasswordButton"
                   v-b-tooltip.hover.leftbottom
                   title="Генерировать пароль"
                   @click="generate()" :class="$style['outline-input-special']">
                <i class="far fa-key"></i>
            </b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>

    export default {
        name: "PasswordInputWrapper",
        props: {
            placeholder: '',
            value: null,
            required: false,
            disabled: null,
            generateLength: 8,
            autocomplete: {
                type: String,
                default: 'off'
            }
        },
        data() {
            return {
                type: 'text',
            }
        },
        methods: {
            changed(value) {
                this.$emit('input', value);
            },
            generate() {
                let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
                let randomString = '';
                for (let i = 0; i < this.$props.generateLength; i++) {
                    let rnum = Math.floor(Math.random() * chars.length);
                    randomString += chars.substring(rnum, rnum + 1);
                }
                this.changed(randomString);
                setTimeout(() => {
                    this.$data.type = 'text';
                }, 200);
                this.$emit('generated-new-password');
            }
        },
        watch: {
            value(value, oldValue) {
                if (value && value !== oldValue) {
                    this.$data.type = 'password';
                }
            }
        }
    }
</script>

<style lang="scss" module>
    @import '../../scss/variables/variables';

    .outline-input-special {
        background-color: white !important;
        border-color: $input-border-color !important;
        color: $input-border-color !important;
        min-width: 3rem;

        &:disabled {
            opacity: 1;
            background-color: $gray-100 !important;
        }
    }
</style>